import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DetailsVehicleBannerComponent } from '../../../components/details-vehicle-banner/details-vehicle-banner.component';

import { BannerAppComponent } from '../../../../components/banner-app/banner-app.component';
import { FooterAppComponent } from '../../../../components/footer-app/footer-app.component';
import { DataLayerService } from '../../../../services/DataLayer/data-layer.service';
import { InactivityService } from '../../../../services/inactivity/inactivity.service';
import { AccessoriesComponent } from '../../components/accessories/accessories.component';

@Component({
  selector: 'app-onerous-accesories-page',
  templateUrl: './onerous-accesories-page.component.html',
  styleUrl: './onerous-accesories-page.component.scss',
  standalone: true,
  imports: [
    //MODULOS
    CommonModule,
    FormsModule,

    //COMPONENTES
    //HeaderComponent,
    FooterAppComponent,
    DetailsVehicleBannerComponent,
    AccessoriesComponent,
    BannerAppComponent,
  ],
})
export class OnerousAccesoriesPageComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);
  private dataLayerService = inject(DataLayerService);
  inactivityService = inject(InactivityService);

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'onerosos');
    this.inactivityService.stopTimer();
    this.inactivityService.startDefaultTimerForScreen(
      'Detalles-Accesorios',
      'Abandono Accesorios',
      '40',
    );

    this.dataLayerService.pushDataLayerOnerous(
      'Pageview',
      'moto_ecommerce_step_2.4_Accesorios',
      'Accesorios',
    );
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'onerosos');
    this.inactivityService.stopTimer();
  }
}
